export const safeString = (val, fallback = "") => {
  if (val === null || val === undefined) return fallback;
  return String(val);
};

export const safeNumber = (val, fallback = 0) => {
  if (val === null || val === undefined || val === "") return fallback;
  const num = Number(val);
  return isNaN(num) ? fallback : num;
};

export const safeJsonParse = (val, fallback = {}) => {
  if (!val) return fallback;
  if (typeof val === "object") return val;
  try {
    return JSON.parse(val);
  } catch (err) {
    console.warn("safeJsonParse error:", err);
    return fallback;
  }
};

export const safeArray = (val, fallback = []) => {
  if (Array.isArray(val)) return val;
  return fallback;
};

/**
 * Validates calculator data before sending calculation request
 * Returns an array of error strings (empty if valid)
 */
export const validateCalculatorInputs = (calculatorData, selectedVessel) => {
  const errors = [];

  if (!calculatorData) {
    errors.push("Calculator state is invalid.");
    return errors;
  }

  const portOperations = safeArray(calculatorData.portOperation);
  if (portOperations.length === 0) {
    errors.push("At least one port operation is required.");
  }

  const fleetList = safeArray(calculatorData.fleetList);
  if (fleetList.length === 0) {
    errors.push("At least one vessel is required in fleet list.");
  }

  if (selectedVessel && typeof selectedVessel === "object") {
    const vesselDetails = safeJsonParse(selectedVessel.vessel, {});
    const ballSpd = safeNumber(vesselDetails.vesselBalSpd1 || selectedVessel.speedBallast, 0);
    const ldnSpd = safeNumber(vesselDetails.vesselLdnSpd1 || selectedVessel.speedLaden, 0);

    if (ballSpd <= 0 && ldnSpd <= 0) {
      errors.push("Selected vessel speed must be greater than zero.");
    }
  }

  return errors;
};
